exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-autocomplete[data-v-05249569]{width:100%}", ""]);

// exports
